import React from 'react'

export default [
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 96 112"
    enableBackground="new 0 0 96 112"
    xmlSpace="preserve"
    key="icon_1"
  >
    <g>
      <path
        fill="#000000"
        d="M68.3 95.2c-6.7 8.7-16.8 15.5-32.6 15.5c-20.2 0-34.3-12.7-34.3-30.4c0-17.8 12.6-28.4 25.2-36.9 c-8.2-2.7-14.1-9.9-14.1-20c0-13.2 11.1-22 23.4-22c12.4 0 23.5 8.8 23.5 22c0 9.9-7.1 18.5-15.8 20.2l25.8 33.2 c5.2-9.1 8.8-21.6 8.8-36h12c0 16.8-4.9 33.5-13.4 45.7l17.8 22.6H79.4L68.3 95.2z M60.9 85.4L34.3 50.5 c-11.1 8.3-19.3 16.5-19.3 27.3c0 12.1 9.7 20.6 20.9 20.6C47.4 98.5 55.6 93.3 60.9 85.4z M35.9 35.4c6.8 0 12.1-5.5 12.1-12 c0-6.7-5.5-12.1-12.1-12.1c-6.7 0-12 5.3-12 12.1C23.9 29.9 29.2 35.4 35.9 35.4z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 87 112"
    enableBackground="new 0 0 87 112"
    xmlSpace="preserve"
    key="icon_2"
  >
    <g>
      <path
        fill="#000000"
        d="M72.3 92.7c8.7 9.3 13.1 14 13.3 14.2c0.2 0.2 0.3 0.6 0.3 1.1c0 1.1-0.5 1.6-1.6 1.6h-9.9 c-0.6 0-1.1-0.1-1.4-0.3c-0.3-0.2-1.2-1.1-2.7-2.7l-5.4-5.9c-7.7 6.5-17.2 9.8-28.5 9.8c-10.7 0-19.3-2.3-25.7-6.8 c-6.4-4.6-9.6-11.1-9.6-19.5v-1.2c0-5.9 1.6-10.9 4.8-15.2c3.2-4.2 8.5-8.6 15.9-13.3c-6.7-7.7-11.1-13.6-13-17.6 c-2-4-3-7.9-3-11.6v-1.1c0-7.4 2.6-13.1 7.9-17c5.3-4 12.7-6 22.4-6c8.6 0 15.6 2 20.9 6.1c5.3 4.1 7.9 9.7 7.9 16.9v1.1 c0 5.6-1.7 10.5-5.2 14.6c-3.5 4.1-10.4 9.7-21 16.7L64.9 85c3.8-6.7 5.6-15.2 5.6-25.5v-2c0-1.6 0.8-2.3 2.3-2.3H79 c1.6 0 2.5 0.8 2.5 2.3v2C81.4 72.6 78.4 83.7 72.3 92.7z M57.9 93.4L29.2 62.6c-5.2 3.2-9 6.2-11.3 9.1c-2.4 2.8-3.5 6.7-3.5 11.5 v1.2c0 5.2 2 9.3 6 12.1c4 2.9 9.4 4.3 16.1 4.3C45 100.7 52.2 98.3 57.9 93.4z M52.9 25.5v-1.1c0-8.9-5.6-13.3-16.8-13.3 c-12.3 0-18.5 4.4-18.5 13.3v1.1c0 3.1 0.8 6 2.3 8.9c1.5 2.9 5.3 7.7 11.5 14.4c8.9-5.5 14.7-9.5 17.4-12.2 C51.5 33.9 52.9 30.2 52.9 25.5z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 102 112"
    enableBackground="new 0 0 102 112"
    xmlSpace="preserve"
    key="icon_3"
  >
    <g>
      <path
        fill="#000000"
        d="M15.2 25.6c0-4.5 1.2-8.5 3.5-12.2c2.3-3.7 5.8-6.6 10.3-8.8c4.5-2.2 9.8-3.2 15.9-3.2 c6.1 0 11.3 1.1 15.7 3.4c4.4 2.3 7.7 5.2 9.9 8.9c2.2 3.7 3.3 7.4 3.3 11.4c0 5.4-1.8 10.1-5.3 14.1c-3.6 4-8.8 8-15.7 12.2 c2.4 2.8 4.6 5.5 6.7 8c2.1 2.5 4.1 4.8 6 7c1.9 2.2 3.7 4 5.3 5.5c0.7-1.3 1.8-3.9 3.4-7.6c1.5-3.7 2.9-6.4 4.3-8 c1.3-1.6 3.2-2.5 5.6-2.5c2.3 0 4.3 0.8 6 2.4c1.7 1.6 2.6 3.6 2.6 5.9c0 2.1-0.7 5.1-2.2 9c-1.5 3.9-3.7 8.2-6.5 12.9 c1.8 1.5 4.6 3.9 8.5 7c3.9 3.1 6.2 5.3 7.1 6.4c0.9 1.1 1.3 2.6 1.3 4.5c0 2.5-0.9 4.6-2.7 6.3c-1.8 1.7-3.8 2.6-6 2.6 c-2.3 0-4.4-0.7-6.6-2.2c-2.1-1.4-6.6-5-13.5-10.6c-3.1 2.9-6.4 5.3-9.7 7.2c-3.3 1.9-6.9 3.3-10.7 4.2c-3.8 0.9-8.1 1.4-12.8 1.4 c-6 0-11.4-0.9-16.2-2.6c-4.8-1.8-8.8-4.1-11.9-7.1c-3.2-3-5.5-6.3-7.1-9.9C2 87.4 1.3 83.7 1.3 79.9C1.3 76.3 1.8 73 3 70 c1.2-3 2.8-5.7 4.9-8.1c2.1-2.4 4.7-4.7 7.7-6.9c3.1-2.2 6.6-4.3 10.6-6.4c-3.6-4.5-6.3-8.5-8.2-12.1C16.2 33 15.2 29.3 15.2 25.6z M35.6 60.1c-4.9 2.8-8.6 5.7-11 8.5c-2.4 2.8-3.6 6.2-3.6 10.1c0 2.2 0.4 4.3 1.3 6.3c0.9 2 2.2 3.9 3.9 5.6 c1.7 1.7 3.7 3.1 5.9 4c2.3 0.9 4.6 1.4 7.1 1.4c2.4 0 4.8-0.4 7.1-1.2c2.3-0.8 4.5-1.9 6.6-3.3c2.1-1.4 4.2-3.2 6.4-5.3 c-4.3-3.9-8.1-7.8-11.5-11.7C44.5 70.7 40.4 65.9 35.6 60.1z M43 40.4c4.9-3.1 8.4-5.8 10.6-7.9c2.2-2.1 3.3-4.7 3.3-7.7 c0-3-1.1-5.5-3.3-7.5c-2.2-2-4.9-3-8.3-3c-3.3 0-6.1 1-8.3 3.1c-2.2 2.1-3.4 4.5-3.4 7.3c0 1.4 0.4 3 1.3 4.7 c0.8 1.7 1.9 3.3 3.1 4.9C39.3 35.8 41 37.9 43 40.4z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 99 112"
    enableBackground="new 0 0 99 112"
    xmlSpace="preserve"
    key="icon_4"
  >
    <g>
      <path
        fill="#000000"
        d="M87.4 110.6c-4.7 0-10.3-0.9-15.8-6.2l-5.5-5.3c-4.4 4.8-13 11.4-29 11.4c-23.6 0-35.7-13.3-35.7-31.1 c0-13 10.3-24 20.8-30c-5.2-5.9-10-13.4-10-20.6c0-14 10.6-27.5 30.9-27.5c15.9 0 26.9 9.4 26.9 24.7c0 10.6-9.1 20.3-22.6 27.9 c4.5 5.8 13.4 16.2 19.2 21.9c5.5-6.1 10.6-17.5 10.9-27.3h4.2c4.7 0 8.7 3 8.7 10.9c0 8.7-7.3 20.6-12.6 27.8l3.1 3 c7 6.7 11.6 8.3 16.9 8.6C97.7 106.6 94.7 110.6 87.4 110.6z M31.9 61.6c-5.3 3.1-10.6 8.7-10.6 15.6c0 12.2 6.7 16.7 18.4 16.7 c5.5 0 11.9-2.3 15.5-6.1C49.3 82.1 36.8 68.5 31.9 61.6z M42.1 16.5c-7 0-10.8 3.9-10.8 11.2c0 5.8 4.1 10.1 7.2 14.7 c9.2-5.3 13.6-9.8 13.6-15.9C52.1 19.9 48.3 16.5 42.1 16.5z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 82 112"
    enableBackground="new 0 0 82 112"
    xmlSpace="preserve"
    key="icon_5"
  >
    <g>
      <path
        fill="#000000"
        d="M76.6 108.2L63.3 91.3c-3 5.5-7.1 10.1-12.2 13.8c-5.1 3.7-11.5 5.5-19.1 5.5c-3.7 0-7.4-0.6-11.1-1.8 c-3.7-1.2-7-2.9-9.8-5.2c-2.8-2.2-5.2-5-7-8.2c-1.8-3.2-2.7-7-2.7-11.2c0-4.4 0.9-8.3 2.7-11.8c1.8-3.4 4.1-6.6 6.9-9.4 c2.8-2.8 5.9-5.3 9.3-7.6c3.4-2.2 6.7-4.4 9.9-6.4c-1.5-2.1-3.1-4.3-4.9-6.5c-1.8-2.2-3.5-4.5-5.2-6.9c-1.6-2.3-3-4.7-4.1-7.2 c-1.1-2.4-1.6-4.9-1.6-7.4c0-3.5 0.6-6.5 1.9-9c1.3-2.5 3-4.5 5-6.1c2-1.6 4.4-2.8 7-3.6c2.6-0.8 5.2-1.2 7.9-1.2 c3 0 5.8 0.4 8.5 1.3c2.6 0.9 5 2.2 7 3.9c2 1.7 3.6 3.8 4.7 6.2c1.1 2.4 1.7 5.3 1.7 8.5c0 3.6-0.8 6.8-2.3 9.5 c-1.5 2.7-3.5 5.2-5.8 7.5c-2.3 2.2-4.8 4.3-7.6 6.2c-2.8 1.9-5.4 3.7-7.8 5.5l28.1 35.6c1-2.2 1.9-4.9 2.7-8.1 c0.8-3.2 1.1-6.8 0.9-10.8h3c0.1 4.5-0.3 8.4-1 11.6c-0.8 3.2-1.9 6.6-3.4 10l15.7 19.9H76.6z M22.7 57.6c-3.2 2.1-6.2 4.4-8.9 7 c-2.7 2.5-4.9 5.4-6.7 8.6c-1.7 3.2-2.6 6.9-2.6 11.1c0 3.8 0.8 7.2 2.4 10.1c1.6 2.9 3.7 5.4 6.2 7.4c2.5 2 5.5 3.5 8.8 4.5 c3.3 1 6.7 1.5 10.1 1.5c7.2 0 13.2-1.8 18-5.4c4.8-3.6 8.6-8.2 11.4-13.9L32 51.7C29 53.6 25.9 55.6 22.7 57.6z M18.2 26.1 c0.6 1.7 1.5 3.6 2.8 5.6c1.2 2 2.8 4.4 4.8 7c1.9 2.6 4.3 5.6 7 9.1c2.1-1.5 4.4-3.1 7-4.9c2.6-1.8 5-3.8 7.3-5.9 c2.2-2.1 4.1-4.5 5.7-7.1c1.5-2.6 2.3-5.4 2.3-8.5c0-2.6-0.5-4.9-1.5-7c-1-2.1-2.4-3.9-4.1-5.3c-1.7-1.4-3.7-2.6-6-3.4 c-2.2-0.8-4.6-1.2-7.1-1.2c-2.6 0-5 0.4-7.3 1.1c-2.3 0.7-4.3 1.8-6.1 3.3c-1.7 1.4-3.1 3.2-4.1 5.2c-1 2-1.5 4.4-1.5 7 C17.3 22.7 17.6 24.4 18.2 26.1z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 115 113"
    enableBackground="new 0 0 115 113"
    xmlSpace="preserve"
    key="icon_6"
  >
    <g>
      <path
        fill="#000000"
        d="M69 100.4c-10.1 8-17 10.7-30.7 10.7C9.7 111.1 1.7 94 1.7 81.6C1.7 64 16.8 55 26.4 51.4 c-5.4-6.3-8.3-12.6-8.3-20.8c0-14.8 11.4-28.7 34.3-28.7c25.1 0 33 16.3 33 28.6c0 13.7-8.1 22-19.1 28.7l6.6 7.2l17-14.9L108 70.3 L91.7 84.8l21.5 23.5H76.4L69 100.4z M41.5 69.9c-4.8 3.3-8 5-8 10.8c0 4.1 3.3 6 7.4 6c3 0 6-1.2 10.2-5.3L41.5 69.9z M60.1 31.4 c0-5.1-4.2-6.5-6.8-6.5c-2.3 0-6.2 1.5-6.2 7.1c0 4.1 2 6.8 5 9.9C56.2 39.2 60.1 36 60.1 31.4z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 98 115"
    enableBackground="new 0 0 98 115"
    xmlSpace="preserve"
    key="icon_7"
  >
    <g>
      <path
        fill="#000000"
        d="M94.7 112.3c-0.6 1-1.5 1.3-2.8 0.8c-1.5-0.7-3.3-1.7-5.3-3c-2-1.3-4.1-2.7-6.3-4.3c-2.2-1.5-4.4-3.2-6.6-5 c-2.2-1.8-4.3-3.6-6.1-5.3c-5.5 3.9-11.1 6.9-17 8.9c-5.9 2-11.6 3-17.2 3c-4.5 0-8.8-0.6-12.7-1.7c-3.9-1.1-7.3-2.9-10.2-5.3 C7.7 98 5.4 95 3.7 91.5C2 87.9 1.1 83.7 1.1 78.7c0-7 2.2-13.3 6.7-18.8c4.4-5.5 10.8-10.7 19.2-15.4c-2.7-3.9-4.8-7.8-6.3-11.5 c-1.5-3.8-2.2-7-2.2-9.7c0-3.1 0.5-6 1.5-8.6c1-2.6 2.4-4.9 4.2-6.8c1.8-1.9 4-3.4 6.6-4.6c2.6-1.1 5.5-1.7 8.8-1.7 c6.5 0 11.6 1.8 15.2 5.5c3.6 3.7 5.4 8.2 5.4 13.5c0 5.6-1.9 10.4-5.6 14.5c-3.7 4.1-9 8.2-15.8 12.1c4.1 6.6 8.8 13.2 14 19.7 c5.2 6.5 10.5 12.5 16 17.9c5-5 9.2-10.7 12.7-17.3c3.5-6.6 5.8-13.9 6.8-22c0.2-0.5 0.4-0.9 0.6-1.2c0.2-0.3 0.6-0.4 1.2-0.4 l3.2 0.2c0.7 0.1 1.2 0.4 1.3 0.8c0.2 0.4 0.2 0.9 0.2 1.4c-0.3 4.3-1.1 8.6-2.5 12.9c-1.3 4.3-3 8.4-5 12.2 c-2 3.9-4.1 7.4-6.5 10.7c-2.4 3.2-4.7 6-7 8.1c3.5 3.3 7.2 6.4 11 9.3c3.8 2.9 7.5 5.3 11 7.3c0.9 0.6 1.1 1.3 0.6 2.2L94.7 112.3 z M62.2 89.9c-2.8-2.7-5.6-5.7-8.6-9c-2.9-3.3-5.8-6.7-8.5-10.2c-2.7-3.5-5.3-7-7.7-10.4c-2.4-3.4-4.6-6.6-6.4-9.6 c-6.5 3.6-11.8 7.6-15.9 12.1C11.1 67.2 9 72.4 9 78.4c0 3.8 0.6 7.1 1.9 9.8c1.2 2.7 2.9 5 5.1 6.7c2.2 1.8 4.7 3.1 7.6 3.9 c2.9 0.9 5.9 1.3 9.1 1.3c4.6 0 9.5-0.8 14.5-2.5C52.2 96.1 57.2 93.5 62.2 89.9z M51.9 21.3c0-3.6-1.2-6.6-3.6-8.9 c-2.4-2.3-5.4-3.5-9.1-3.5c-2.3 0-4.2 0.5-5.7 1.4c-1.5 0.9-2.8 2.1-3.7 3.5c-0.9 1.4-1.6 2.9-2 4.4c-0.4 1.5-0.6 3-0.6 4.3 c0 2.7 0.6 5.5 1.9 8.6c1.3 3 3.1 6.3 5.5 9.7c2.5-1.2 4.8-2.6 6.9-3.9c2.1-1.4 3.9-2.9 5.5-4.4c1.5-1.5 2.8-3.3 3.6-5.1 C51.4 25.5 51.9 23.5 51.9 21.3z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 88 112"
    enableBackground="new 0 0 88 112"
    xmlSpace="preserve"
    key="icon_8"
  >
    <g>
      <path
        fill="#000000"
        d="M67.3 107.9l-5.2-6.2c-7.6 5.9-16.5 8.8-26.8 8.8c-9.8 0-17.8-3.1-24.2-9.3c-6.4-6.2-9.6-14-9.6-23.5 c0-7.4 1.9-13.5 5.7-18.5c3.8-4.9 10.1-9.3 18.9-13C22 37.1 20 29.8 20 24.2c0-6.7 2.1-12.2 6.3-16.4c4.2-4.2 9.7-6.3 16.5-6.3 c6.5 0 11.7 1.9 15.8 5.6c4.1 3.7 6.1 8.5 6.1 14.5c0 10.4-7.3 19.8-21.9 28.1C48.2 60.2 56 71.6 66.2 84 c4.4-6.5 6.6-15.2 6.6-26.1l-0.1-5.3h13.8c-1 17.3-5.6 30.5-13.9 39.7c4.4 5.2 9 10.4 13.9 15.6H67.3z M56.1 93.6 C45 80.2 36.5 67.3 30.3 54.9C20.7 59.6 16 66.3 16 74.9c0 7 2.1 13 6.4 17.9c4.3 4.9 9.4 7.4 15.5 7.4 C43.7 100.1 49.8 98 56.1 93.6z M38.7 40.5c8.8-4.2 13.3-10.2 13.3-17.9c0-3.1-0.8-5.7-2.5-7.7c-1.7-2-3.8-3-6.4-3 c-2.6 0-4.7 1.1-6.6 3.2c-1.8 2.1-2.7 4.7-2.7 7.7C33.8 27.2 35.4 33.1 38.7 40.5z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 98 112"
    enableBackground="new 0 0 98 112"
    xmlSpace="preserve"
    key="icon_9"
  >
    <g>
      <path
        fill="#000000"
        d="M79.2 109L69 99.3c-8.4 7.8-18.8 11.3-30.5 11.3c-20.2 0-37.5-13-37.5-34c0-13.9 6.9-22.4 18.5-28.8 c-4.5-6.7-8.1-13.1-8.1-21.5C11.5 9 26 1.4 41.5 1.4C54.4 1.4 68 8.1 68 22.6c0 17.3-18.8 22.7-31.6 28.4 c10.2 10.6 20.5 20.8 31.2 30.8c2.2-5.2 3.1-13.9 3.4-19.4h11.9C82.3 73.5 81.5 80 76.5 90l20.5 19H79.2z M25.9 55.9 c-7.9 4.2-12.4 10.9-12.4 20c0 14.9 11.8 25.2 26.3 25.2c9 0 16.1-2.7 21.8-9C49.4 80.2 37.5 68.2 25.9 55.9z M41.2 10.8 c-9.4 0-17.6 4.5-17.6 14.8c0 6.6 3.1 11.6 6.6 17c3.9-1.6 7.8-3.3 11.6-5.1c6.4-3 13.9-6.9 13.9-15.1 C55.7 14.4 48.4 10.8 41.2 10.8z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 85 113"
    enableBackground="new 0 0 85 113"
    xmlSpace="preserve"
    key="icon_10"
  >
    <g>
      <path
        fill="#000000"
        d="M54.1 1.2c1 0 2.1 0 3.1 0c0.4 0.1 0.8 0.1 1.2 0.2c5.1 0.7 9.3 3 11.9 7.4c3.8 6.6 3.4 13.2-0.8 19.6 c-2 3.1-4.8 5.4-7.7 7.6c-5.5 4.2-11.4 7.6-17.2 11.4c-1 0.7-1.3 1.3-1 2.6c1.2 4.6 2.7 9.1 4.6 13.5c2.2 5 4.9 9.7 8.1 14 c0.5 0.7 0.9 1.1 1.3-0.1c3.7-9.2 6.2-18.6 6.8-28.5c0.2-3.3 0.6-3.9 3.8-4.7c0.4-0.1 0.8-0.2 1.2-0.3c5.3-0.9 9.1 2.3 8.9 7.3 c-0.2 4.6-1.1 9-2.6 13.4c-2.6 7.3-6.4 14-11.1 20.2c-0.7 0.9-0.6 1.4 0.2 2.2c4.6 4.1 9.6 7.7 15.3 10.3c4.1 1.9 4.2 2.2 3.7 6.6 c-0.4 4.1-2.8 6.8-6.8 7.6c-4.5 0.9-8.8-0.1-12.9-2c-4.7-2.2-8.7-5.4-12.2-9.2c-0.8-0.8-1.3-0.9-2.2-0.2c-1.8 1.3-3.7 2.6-5.6 3.8 c-6.7 4-13.8 6.6-21.8 5.6c-6.5-0.8-12-3.6-16.2-8.7c-2.8-3.5-4.3-7.6-4.9-12c0-1.5 0-3 0-4.5c0.1-0.3 0.1-0.5 0.2-0.8 c0.6-6.3 3.1-11.8 6.9-16.7c4.6-6 10.4-10.6 16.5-14.8c2.6-1.8 2.1-1.1 1.6-3.8c-1.9-10.2-1.3-20.2 3.2-29.8 c3.3-6.9 8.2-12.1 15.4-15C47.8 2.1 50.9 1.6 54.1 1.2z M33.8 101.6c5-0.3 9.1-2.6 12.6-6.2c0.5-0.6 0.5-1 0-1.6 c-0.9-1.2-1.8-2.4-2.6-3.7c-6.2-9-10.7-18.9-14.2-29.2c-0.5-1.5-0.6-1.5-1.7-0.4c-8.9 9.3-10.8 22.8-4.7 34.1 C25.4 98.7 28.7 101.4 33.8 101.6z M40.9 27.7c0 3.7 0.3 7.7 0.8 11.7c0.1 0.6 0.1 1.2 1 0.6c4.1-3 8.3-5.9 11.7-9.8 c3.8-4.4 6.1-9.3 5.9-15.3c-0.2-4.5-3-8-6.6-8.3c-4.8-0.4-8.5 2-10.4 6.4C41.3 17.6 40.8 22.4 40.9 27.7z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 107 112"
    enableBackground="new 0 0 107 112"
    xmlSpace="preserve"
    key="icon_11"
  >
    <g>
      <path
        fill="#000000"
        d="M56.8 49.8l18.4 29.3c0.2 0.7 1 2 2.5 4.1c6.6-9 10.6-21.2 12-36.8H74.4v-4.1h31.2v4.1H93.5 c-1.1 16.8-5.5 30.1-13.4 40l12.8 17.7h11.7v4H73c-2.3-3.3-4.4-6.1-6.3-8.4c-9.1 7.2-19.2 10.8-30.3 10.8 c-11.1 0-19.7-2.9-25.8-8.7c-6.1-5.8-9.2-12.8-9.2-21c0-7.7 2.7-14.7 8.2-20.8C15 54 22.8 49.4 33 46.3c-6-10.3-9.1-18.1-9.1-23.6 c0-5.7 2.5-10.6 7.4-14.9c5-4.3 11.1-6.4 18.6-6.4c7.2 0 13.5 1.7 18.8 5.2c5.3 3.5 7.9 8 7.9 13.6c0 4.6-1.7 8.6-5.2 12.1 c-3.5 3.5-9.8 6.9-18.8 10.2L56.8 49.8z M34.9 49.7c-11.2 4.2-16.8 10.1-16.8 17.6c0 7 2.8 15 8.5 24c5.6 9 12.2 13.5 19.6 13.5 c5.7 0 11.9-2.7 18.6-8C53.1 79.8 43.1 64.2 34.9 49.7z M50.5 39.1c5.1-2.1 8.4-4.5 10-7.3c1.5-2.8 2.3-6.7 2.3-11.5 c0-9.9-4.2-14.9-12.6-14.9c-3.2 0-5.9 0.9-8 2.6c-2.1 1.7-3.2 3.9-3.2 6.5C39.1 19.1 42.9 27.3 50.5 39.1z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 74 112"
    enableBackground="new 0 0 74 112"
    xmlSpace="preserve"
    key="icon_12"
  >
    <g>
      <path
        fill="#000000"
        d="M72.5 109.2h-9.9l-7.1-10.6c-5.5 8.1-15.7 12-25.5 12c-17.5 0-28.5-11-28.5-29.4c0-15.5 10-24.9 21.2-33 C16.4 39 11.8 32.2 11.8 20.5c0-12.2 7.8-19.1 19.3-19.1c10.9 0 19.1 7 19.1 18.6c0 13.3-7.1 21.7-16.8 29l21.7 33.9 c2.8-6.5 3.8-14.8 3.8-22.3h9c0 8-2.6 22-7 30.1L72.5 109.2z M26.4 54.8C16.7 62.1 10.6 69 10.6 82.1c0 12.5 7.8 20.6 19.7 20.6 c8.7 0 15.4-3 20.3-11L26.4 54.8z M30.5 9.3c-6.7 0-10.6 3.9-10.6 10.9c0 8.5 4.3 16.2 9 22.6c7-4.8 12.3-12.9 12.3-21.9 C41.2 13.2 38 9.3 30.5 9.3z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 96 112"
    enableBackground="new 0 0 96 112"
    xmlSpace="preserve"
    key="icon_13"
  >
    <g>
      <path
        fill="#000000"
        d="M46.7 49.9l19 23l0.6-0.7c2.1-2.2 4-4.4 5.8-6.6c1.8-2.1 3.6-4.3 5.3-6.5l10.4 10.7c-1.3 1.8-3 3.9-5 6.4 c-2.1 2.4-4.5 5.2-7.4 8.3l19.5 24.1H75.1L64.6 95.7c-9.7 10-19.7 15-30.1 15c-9.3 0-17.3-3-23.8-9c-6.4-6-9.6-13.4-9.6-22.3 c0-10.5 5.1-19.3 15.2-26.2l6.9-4.7c0.1 0 0.2-0.2 0.5-0.3c0.2-0.2 0.5-0.4 1-0.8c-7-7.4-10.5-14.7-10.5-21.9 c0-7.1 2.3-12.9 7-17.4C25.8 3.6 32 1.4 39.4 1.4c7.2 0 13.2 2.2 18 6.5c4.7 4.3 7.1 9.8 7.1 16.4c0 4.6-1.3 8.7-3.9 12.4 C58.1 40.3 53.4 44.7 46.7 49.9z M34.1 58.8l-0.9 0.6c-6.5 4.5-11 8.1-13.3 10.9c-2.3 2.7-3.5 5.6-3.5 8.7c0 4.4 1.8 8.4 5.3 12 c3.6 3.5 7.7 5.3 12 5.3c6.2 0 13.2-4 21.3-12.1L34.1 58.8z M37.5 38.7l1.3-1c2.2-1.7 4.1-3.2 5.5-4.4c1.5-1.3 2.5-2.3 3.1-3.2 c1.4-1.7 2.1-3.8 2.1-6.2c0-2.8-0.9-5-2.8-6.8c-1.9-1.7-4.4-2.6-7.5-2.6c-2.9 0-5.3 0.9-7.2 2.7c-2 1.7-2.9 3.8-2.9 6.5 c0 3.1 1.2 6.2 3.7 9.2l4 4.8C36.8 37.9 37.1 38.2 37.5 38.7z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 109 112"
    enableBackground="new 0 0 109 112"
    xmlSpace="preserve"
    key="icon_14"
  >
    <g>
      <path
        fill="#000000"
        d="M107.6 109H88.5L65.6 86l-16.3 16.4c-5.2 5.4-12.3 8.2-19.9 8.2c-7.5 0-14.5-2.8-19.9-8.2 c-10.9-10.9-10.9-28.9 0-39.8L26 46.2l-6.6-6.7c-8.8-9.1-8.7-23 0-31.7c8.5-8.5 23.2-8.5 31.7 0c8.7 8.8 8.7 23 0 31.9l-6.3 6.3 l20.8 20.8c2.7-3.4 3.9-7.3 3.9-11.5c-0.2-2.8-0.7-5.5-1.8-8.1l10.6-8.2c2.5 4.9 4 10.3 4.2 16.3v0.1c0 7.8-2.4 15.3-7.5 21.1 L107.6 109z M56.3 77.1L35 55.8L18.5 72.2C12.8 78 13 87.5 18.8 93.3c2.8 2.8 6.6 4.5 10.6 4.5c4 0 7.9-1.6 10.8-4.5L56.3 77.1z M29.1 30.8l6.1 6.1l6.6-6.6c3.7-3.7 3.7-9.6 0-13.3c-3.9-3.9-9.4-3.9-13.2 0c-1.8 1.8-2.8 4.2-2.8 6.6 C25.8 26.1 26.9 28.5 29.1 30.8z"
      />
    </g>
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 101 112"
    enableBackground="new 0 0 101 112"
    xmlSpace="preserve"
    key="icon_15"
  >
    <path
      fill="#000000"
      d="M73.9 81.2L90.6 55H76.1L65.4 72.1l-20.4-22c7.7-4.5 19.8-12.5 19.8-25c0-14.3-12-23.8-25.4-23.8 C25.6 1.4 14 10.9 14 25c0 8.8 5.8 16.2 11.6 22.2C12.8 55 1.1 63.2 1.1 79c0 17.2 14 31.7 33.3 31.7c15.3 0 25.6-10.9 32-19.3 L83.1 109h16.8L73.9 81.2z M39.3 12.4c7.4 0 13.2 4.9 13.2 12c0 8.8-9.8 13.8-15.9 16.8C31.8 36.6 26.2 30.7 26.2 24 C26.2 17.7 31.7 12.4 39.3 12.4z M33.8 98.9c-9.7 0-19.9-8.3-19.9-18.1c0-11.3 9.7-19.2 20.1-24.2l23.9 25.7 C52.4 89.4 45.1 98.9 33.8 98.9z"
    />
  </svg>,
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 82 112"
    enableBackground="new 0 0 82 112"
    xmlSpace="preserve"
    key="icon_16"
  >
    <g>
      <path
        fill="#000000"
        d="M76.6 108.2L63.3 91.3c-3 5.5-7.1 10.1-12.2 13.8c-5.1 3.7-11.5 5.5-19.1 5.5c-3.7 0-7.4-0.6-11.1-1.8 c-3.7-1.2-7-2.9-9.8-5.2c-2.8-2.2-5.2-5-7-8.2c-1.8-3.2-2.7-7-2.7-11.2c0-4.4 0.9-8.3 2.7-11.8c1.8-3.4 4.1-6.6 6.9-9.4 c2.8-2.8 5.9-5.3 9.3-7.6c3.4-2.2 6.7-4.4 9.9-6.4c-1.5-2.1-3.1-4.3-4.9-6.5c-1.8-2.2-3.5-4.5-5.2-6.9c-1.6-2.3-3-4.7-4.1-7.2 c-1.1-2.4-1.6-4.9-1.6-7.4c0-3.5 0.6-6.5 1.9-9c1.3-2.5 3-4.5 5-6.1c2-1.6 4.4-2.8 7-3.6c2.6-0.8 5.2-1.2 7.9-1.2 c3 0 5.8 0.4 8.5 1.3c2.6 0.9 5 2.2 7 3.9c2 1.7 3.6 3.8 4.7 6.2c1.1 2.4 1.7 5.3 1.7 8.5c0 3.6-0.8 6.8-2.3 9.5 c-1.5 2.7-3.5 5.2-5.8 7.5c-2.3 2.2-4.8 4.3-7.6 6.2c-2.8 1.9-5.4 3.7-7.8 5.5l28.1 35.6c1-2.2 1.9-4.9 2.7-8.1 c0.8-3.2 1.1-6.8 0.9-10.8h3c0.1 4.5-0.3 8.4-1 11.6c-0.8 3.2-1.9 6.6-3.4 10l15.7 19.9H76.6z M22.7 57.6c-3.2 2.1-6.2 4.4-8.9 7 c-2.7 2.5-4.9 5.4-6.7 8.6c-1.7 3.2-2.6 6.9-2.6 11.1c0 3.8 0.8 7.2 2.4 10.1c1.6 2.9 3.7 5.4 6.2 7.4c2.5 2 5.5 3.5 8.8 4.5 c3.3 1 6.7 1.5 10.1 1.5c7.2 0 13.2-1.8 18-5.4c4.8-3.6 8.6-8.2 11.4-13.9L32 51.7C29 53.6 25.9 55.6 22.7 57.6z M18.2 26.1 c0.6 1.7 1.5 3.6 2.8 5.6c1.2 2 2.8 4.4 4.8 7c1.9 2.6 4.3 5.6 7 9.1c2.1-1.5 4.4-3.1 7-4.9c2.6-1.8 5-3.8 7.3-5.9 c2.2-2.1 4.1-4.5 5.7-7.1c1.5-2.6 2.3-5.4 2.3-8.5c0-2.6-0.5-4.9-1.5-7c-1-2.1-2.4-3.9-4.1-5.3c-1.7-1.4-3.7-2.6-6-3.4 c-2.2-0.8-4.6-1.2-7.1-1.2c-2.6 0-5 0.4-7.3 1.1c-2.3 0.7-4.3 1.8-6.1 3.3c-1.7 1.4-3.1 3.2-4.1 5.2c-1 2-1.5 4.4-1.5 7 C17.3 22.7 17.6 24.4 18.2 26.1z"
      />
    </g>
  </svg>
]
